import * as React from 'react';
import { Heart16, HeartStroke16 } from '@cian/ui-kit/icons';
import { IFavoriteButtonProps } from '../../../types/newbuilding/favorite';
import * as style from './HeartFavoriteButton.css';

export function HeartFavoriteButton({ isFavorite, onClick }: IFavoriteButtonProps) {
  const icon = isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 color="white_100" />;

  return (
    <button onClick={onClick} className={style['favorite_button']}>
      {icon}
    </button>
  );
}
